import { Action, ServerError } from '../types';

export const setServerError = (error: ServerError): Action => ({
  type: 'SERVER_ERROR_UPDATE',
  error,
});
